import React from 'react';
import { blockedScreenContent } from '../utils/blockedScreen';

// The screen a signed-in user sees when their role may not use this board.
// Drivers get "Password set -- open the HMGC Driver app to sign in." plus the
// download link; any other blocked role keeps "Access blocked". The words live in
// utils/blockedScreen.js.
function BlockedScreen({ role, onLogout }) {
  const content = blockedScreenContent(role);
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#1a1a2e',
      padding: '2rem'
    }}>
      <div style={{
        backgroundColor: '#16213e',
        padding: '3rem',
        borderRadius: '10px',
        width: '100%',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>{content.icon}</div>
        <h1 style={{ color: '#fff', fontSize: '1.5rem', marginBottom: '2rem', lineHeight: '1.5' }}>
          {content.title}
        </h1>
        {content.link && (
          <div style={{ marginBottom: '2rem' }}>
            <a
              href={content.link.href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '0.75rem 2rem',
                backgroundColor: '#2e86de',
                color: '#fff',
                borderRadius: '5px',
                fontWeight: 'bold',
                fontSize: '1rem',
                textDecoration: 'none'
              }}
            >
              {content.link.label}
            </a>
            {content.note && (
              <p style={{ color: '#b8c2d6', fontSize: '0.9rem', marginTop: '1rem', lineHeight: '1.4' }}>
                {content.note}
              </p>
            )}
          </div>
        )}
        <button
          onClick={onLogout}
          style={{
            padding: '0.75rem 2rem',
            backgroundColor: '#e74c3c',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '1rem'
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default BlockedScreen;
